


























import ButtonStyle from "@/components/element/ButtonStyle.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

const MINUTES_PER_HOUR = 60;

@Component({
  components: {
    ButtonStyle,
  },
})
export default class ModalBlockLogin extends Vue {
  @Prop({ type: Boolean, default: true })
  private showModal!: boolean;

  @Prop({ type: Number, default: 0 })
  private lockDurationMinutes!: number;

  get descriptionText(): string {
    const duration = this.FormatLockDuration(this.lockDurationMinutes);
    return this.$t("Modal_Block_Login_Description", { duration }) as string;
  }

  FormatLockDuration(totalMinutes: number): string {
    if (totalMinutes < MINUTES_PER_HOUR) {
      return this.$t("X_Minutes", { m: totalMinutes }) as string;
    }
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
    const minutes = totalMinutes % MINUTES_PER_HOUR;
    if (minutes === 0) return this.$t("X_Hours", { h: hours }) as string;
    return `${this.$t("X_Hours", { h: hours })} ${this.$t("X_Minutes", { m: minutes })}`;
  }

  HandleConfirm() {
    this.$emit("update:showModal", false);
  }
}
